import axiosClient from "api/axios_client.js";

// Session calls used app-wide (AuthContext).

export const getProfileApi = async () => {
  const res = await axiosClient.get("/user/get");
  return res.data;
};

export const logoutApi = async () => {
  const res = await axiosClient.post("/user/logout");
  return res.data;
};

export const getAllAssignedModule = async () => {
  const res = await axiosClient.get("/user-role-module/module-master/assigned-modules");
  return res.data;
};
